<template>
  <div class="">
    <div v-if="isShow" class="">
      <div class="bg_white pt16 pb16 boxs2">
        <SectionTitle :title="'お振込確認'" :width="'121'" />
        <h2 class="page_title small ab ml16 mt20 mr16">出金口座情報</h2>
        <BankData :isConfirm="true" />
      </div>

      <div class="bg_white mt12 pt16 pb36 boxs2">
        <h2 class="page_title ab ml16 mr16">取引明細</h2>
        <WithdrawDetail :ml="'16'" :isConfirm="true" :large="true" :orderPattern="'confirm'" />
        <div class="btn_wrap">
          <button class="btn_blue ab bank_btn" @click="withdraw">上記内容で申請します</button>
          <div class="mt24">
            <router-link class="btn_delete back_btn" :to="{ name: 'WalletWithdraw' }">戻る</router-link>
          </div>
        </div>
      </div>
      <!-- <div class="bg_white pt16 pb16 mt12">
        <h2 class="page_title ab ml16 mr16">口座振込額</h2>
        <div class="confirm_list">
          <div class="confirm_title rb c5a">口座振込額</div>
          <div class="confirm_price rm c5a">{{ Number(withdrawPrice).toLocaleString() }}<span class="yen rb">円</span></div>
        </div>
        <div class="btn_wrap">
          <button class="btn_blue ab bank_btn" @click="withdraw">上記内容で申請します</button>
          <div class="mt24">
            <router-link class="btn_delete back_btn" :to="{ name: 'WalletWithdraw' }">戻る</router-link>
          </div>
        </div>
      </div> -->

      <ErrorModal v-if="isErrorModal" :errorMessage="errorMessage" @modalClose="modalClose" />

    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>
</template>

<script>
import Check from '@/model/getToken';
import SectionTitle from '@/components/common/SectionTitle';
import BankData from '@/components/wallet/WithdrawBank';
import WithdrawDetail from '@/components/wallet/WithdrawDetail';
import Wallet from '@/components/api/wallet/wallet';
import ErrorModal from '@/components/common/ErrorModal';
import { mapGetters } from 'vuex';

export default {
  components: {
    SectionTitle,
    BankData,
    WithdrawDetail,
    ErrorModal
  },
  data() {
    return {
      isShow: true,
      isErrorModal: false,
      errorMessage: '',
    }
  },
  methods: {
    modalClose() {
      this.isErrorModal = false;
    },
    async withdraw() {
      this.errorMessage = '';
      await Wallet.withdraw(this.withdrawPrice, this.isBonus).then((val) => {
        console.log('申請');
        console.log(this.withdrawPrice);
        console.log(this.isBonus);
        console.log(val);
        if(val.resultStatus == 'OK') {
          this.$router.push({ name: 'WalletWithdrawComplete' });
        } else {
          this.errorMessage = '申請に失敗しました。<br>再度お試しください<br>' + val.errorDescription;
          this.isErrorModal = true;
        }
      });

    }

  },
  computed: mapGetters(['withdrawPrice', 'isBonus']),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
    } else {
      this.isShow = false;
    }
  },
  watch: {
    editing() {
      this.editing ? this.type = 'number' : this.type = 'text';
    }
  }
}
</script>

<style lang="css" scoped>
.confirm_list {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1;
  margin-top: 13px;
}

.confirm_list .confirm_title {
  font-size: 16px;
}

.confirm_list .confirm_price {
  font-size: 32px;
  margin-top: 8px;
}

.page_title.small {
  font-size: 14px;
}


.btn_wrap {
  margin-top: 16%;
}
.bank_btn {
  letter-spacing: 5.5px;
}

.bank {
  padding-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/wallet/withdraw/WithdrawConfirm.vue